export default class ClientUserPasswordValidationException extends Error {
  public name: string;

  constructor(password: string) {
    super(password);
    this.name = `Password: ${password} is not valid`;
  }
}
